import { render, staticRenderFns } from "./StringAttribute.vue?vue&type=template&id=516368a5"
import script from "./StringAttribute.vue?vue&type=script&lang=js"
export * from "./StringAttribute.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports